// Handle input fields changes

export const getEmptyInvite = () => {
    return {
        eventType: 'nunta',
        eventTypeId: 1,
        eventTitle: '',
        eventDescription: '',
        selectedInvite: '',
        eventStartDateTime: null,
        eventStartDateTimeTimestamp: Math.round(new Date().getTime()/1000),
        locationName: '',
        locationAddress: '',
        locationLat: '',
        locationLong: '',
        churchName: '',
        churchAddress: '',
        churchStartTime: null,
        churchStartTimeTimestamp: Math.round(new Date().getTime()/1000),
        phoneConfirmationName: '',
        phoneConfirmationNumber: '',
        phoneConfirmation: true,
        rsvpConfirmation: false
    };
}

export const fillInviteWithPlaceholders = (invite) => {
    return {
        ...invite,
        eventTitle: invite.eventTitle ? invite.eventTitle : 'Ana si Vlad',
        eventTypeId: invite.eventTypeId ? invite.eventTypeId : '1',
        eventDescription: invite.eventDescription ? invite.eventDescription : 'Cu mare bucurie vă invităm la nunta noastră alături de cei dragi nouă. Suntem foarte încântați să ne sărbătorim căsătoria și sperăm că ne veți putea fi alături.',
        locationName: invite.locationName ? invite.locationName : 'Imperial Ballrooms',
        eventStartDateTime: invite.eventStartDateTime ? invite.eventStartDateTime : new Date(),
        locationAddress: invite.locationAddress ? invite.locationAddress : 'Șoseaua Pipera, Strada Avionului 9, București',
        churchName: invite.churchName ? invite.churchName : 'Sfantul Spiridon Nou',
        churchAddress: invite.churchAddress ? invite.churchAddress : 'Calea Șerban Vodă 29, București',
        churchStartTime: invite.churchStartTime ? invite.churchStartTime : new Date(),
        phoneConfirmationName: invite.phoneConfirmationName ? invite.phoneConfirmationName : 'Ana',
        phoneConfirmationNumber: invite.phoneConfirmationNumber ? invite.phoneConfirmationNumber : '0741844848',
        phoneConfirmation: invite.phoneConfirmation ? invite.phoneConfirmation : true,
        rsvpConfirmation: invite.rsvpConfirmation ? invite.rsvpConfirmation : true
    };
}
